import { render, staticRenderFns } from "./SfImage.vue?vue&type=template&id=5c1493c1&"
import script from "./SfImage.vue?vue&type=script&lang=js&"
export * from "./SfImage.vue?vue&type=script&lang=js&"
import style0 from "./SfImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports